import React from 'react';

const FlagTd = props => (
  <svg viewBox="0 0 450 300" {...props}>
    <path fill="#C60C30" d="M0 0h450v300H0z" />
    <path fill="#FECB00" d="M0 0h300v300H0z" />
    <path fill="#002664" d="M0 0h150v300H0z" />
  </svg>
);

export default FlagTd;
